/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { useGlobalState } from 'src/core/hooks/useGlobalState';
import { useInstallHandlerGroup } from 'src/core/hooks/useInstallHandlerGroup';
import { createQnaMakerAssetsHandlerGroup } from 'src/qnaMaker/modules/handlers/qnas/QnaMakerAssetsHandlerGroup';
import { createQnaMakerSourcesHandlerGroup } from 'src/qnaMaker/modules/handlers/sources/qnaMakerSourcesHandlerGroup';

export const useQnaMakerStartupConfigs = () => {
    const { dispatcher } = useGlobalState();

    useInstallHandlerGroup(dispatcher, createQnaMakerAssetsHandlerGroup, createQnaMakerSourcesHandlerGroup);
};
